import { render } from "./index.vue?vue&type=template&id=4e5527ca"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\McToWebsite\\www\\CustomerWork\\GxTheater\\OfficialWebsite\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__